import { MaterialModule } from '../material.module';
import { AffinisBooleanDialogComponent, AffinisDataTableComponent } from './components';
import { AlertComponent } from './components/alert-label/alert.component';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { ErrorCodeComponent } from './components/error-code/error-code.component';
import { FileUploadComponent } from './components/file-upload/file-upload.component';
import { AffinisInputGroupComponent } from './components/input-group';
import { PageHeaderComponent } from './components/page-header/page-header.component';
import { ReportComponent } from './components/report/report.component';
import { WeSearchComponent } from './components/we-search/we-search.component';
import { YearMonthSelectComponent } from './components/year-month-select/year-month-select.component';
import { CustomMatPaginatorIntl } from './custom-translators';
import { DisableControlDirective } from './directives/disable-control.directive';
import { IfRolesDirective } from './directives/if-role.directive';
import { ObjectOrStringPipe } from './pipes/object-or-string.pipe';
// import { NgrxMatSelectViewAdapterDirective } from './directives/ngrx-mat-select-view-adapter';
import { SafeUrlPipe } from './pipes/safe-url.pipe';
import { ToObservablePipe } from './pipes/to-observable.pipe';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { RouterModule } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { NgrxFormsModule } from 'ngrx-forms';
import { NgProgressModule } from 'ngx-progressbar';
import { NgProgressHttpModule } from 'ngx-progressbar/http';
import { NgProgressRouterModule } from 'ngx-progressbar/router';
import { ToastrModule } from 'ngx-toastr';

const MODULES = [
  MaterialModule,
  NgProgressModule,
  NgProgressRouterModule,
  NgProgressHttpModule,
  NgSelectModule,
  NgrxFormsModule,
  ToastrModule,
  TranslateModule,
];
const COMPONENTS = [
  BreadcrumbComponent,
  PageHeaderComponent,
  ErrorCodeComponent,
  AlertComponent,
  AffinisBooleanDialogComponent,
  AffinisDataTableComponent,
  AffinisInputGroupComponent,
  FileUploadComponent,
  ReportComponent,
  WeSearchComponent,
  YearMonthSelectComponent,
];
const COMPONENTS_DYNAMIC = [];
const DIRECTIVES = [DisableControlDirective, IfRolesDirective];
const PIPES = [SafeUrlPipe, ToObservablePipe, ObjectOrStringPipe];

@NgModule({
  declarations: [...COMPONENTS, ...COMPONENTS_DYNAMIC, ...DIRECTIVES, ...PIPES],
  imports: [CommonModule, FormsModule, RouterModule, ReactiveFormsModule, ...MODULES],
  exports: [
    CommonModule,
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    ...MODULES,
    ...COMPONENTS,
    ...DIRECTIVES,
    ...PIPES,
  ],
  providers: [
    {
      provide: MatPaginatorIntl,
      useClass: CustomMatPaginatorIntl,
    },
  ],
})
export class SharedModule {}
